import { useState } from "react";
import { Card, TextField, Button, Typography, Box } from "@mui/material";
import Swal from "sweetalert2";
import logo from "assets/images/logo.png";

function ContactUs() {
    const [fields, setFields] = useState({ name: "", email: "", mobile: "", message: "" });

    const handleChange = (e) => {
        setFields({ ...fields, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Example: Show success message, in real case you do API call here
        Swal.fire({
            icon: 'success',
            title: 'Thank you for your enquiry!',
            text: 'We will get back to you shortly.',
            confirmButtonText: 'Okay',
        });

        // Optionally clear the form after submit
        setFields({ name: "", email: "", mobile: "", message: "" });
    };

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor="#f5f7fa"
            px={2}
        >
            <Card
                sx={{
                    maxWidth: 450,
                    p: 4,
                    borderRadius: 3,
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)"
                }}
            >
                <Box display="flex" alignItems="center" mb={3} gap={2}>
                    <Box
                        component="img"
                        src={logo}
                        alt="Just Click India Logo"
                        sx={{ width: 60, height: 60, objectFit: "contain" }}
                    />
                    <Typography variant="h4" fontWeight="bold" sx={{ color: '#000' }}>
                        Just Click India
                    </Typography>
                </Box>

                <Typography variant="h5" fontWeight="medium" gutterBottom>
                    Contact Us
                </Typography>

                <form autoComplete="off" onSubmit={handleSubmit}>
                    <TextField
                        name="name"
                        label="Name"
                        value={fields.name}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        required
                        autoFocus
                    />
                    <TextField
                        name="email"
                        label="Email"
                        type="email"
                        value={fields.email}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        name="mobile"
                        label="Mobile Number"
                        type="tel"
                        value={fields.mobile}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        name="message"
                        label="Message"
                        value={fields.message}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        multiline
                        rows={4}
                        required
                    />

                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        fullWidth
                        sx={{
                            mt: 3,
                            py: 1.5,
                            fontWeight: 'bold',
                            fontSize: '1rem',
                            color: '#fff',
                        }}
                    >
                        Enquire Now
                    </Button>
                </form>
            </Card>
        </Box>
    );
}

export default ContactUs;
